import * as React from "react";
import { DifficultyLevelReward } from "./DifficultyLevelReward";
export var ThemedEventReward = function (_a) {
    var className = _a.className, rewardResource = _a.rewardResource, rewardAmount = _a.rewardAmount;
    return (React.createElement("div", { className: className + " difficulty-reward-container flex flex--guts" },
        React.createElement(DifficultyLevelReward, { rewardAmount: rewardAmount, rewardResource: rewardResource })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/ThemedEventReward.tsx
// module id = 2936
// module chunks = 3